module.exports = __webpack_public_path__ + "img/wireless.a6ae2125.png";